const ScreenshotContainer = (props) => {
  return <div className="card-img-top wordpress-preview">
      <img src={props.screenshotUrl} alt="Screenshot" />
    </div>
}

export {ScreenshotContainer}
